<template>
    <div>vgoodslistedit</div>
</template>
<script>
</script>